export enum OrderStatusEnum {
  None,
  Created,
  Splited,
  CreatedBySplit,
  Stored,
  ReadyForPrint,
  PrintedNotPaid,
  Paid,
  Canceled,
  ReadyForClose,
  ClosedNotPaid,
  Closed,
}
